import { render, staticRenderFns } from "./HomeAbout.vue?vue&type=template&id=db37d27e&scoped=true&"
import script from "./HomeAbout.vue?vue&type=script&lang=js&"
export * from "./HomeAbout.vue?vue&type=script&lang=js&"
import style0 from "./HomeAbout.vue?vue&type=style&index=0&id=db37d27e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db37d27e",
  null
  
)

export default component.exports